import * as PIXI from 'pixi.js';
import { ALL_BITMAP_TEXT_STYLE_PROPERTIES, ALL_BITMAP_TEXT_STYLE_TYPES } from '../types/bitmapTextTypes';
// SINGLETON ALERT!
let bitmapFontsAreInitialized = false;
/**
 * Make sure fonts have been preloaded before calling this!
 */
export async function initBitmapFonts() {
    if (bitmapFontsAreInitialized) {
        return;
    }
    const startMs = performance.now();
    console.log(`Creating ${ALL_BITMAP_TEXT_STYLE_TYPES.length} Bitmap Fonts...`);
    ALL_BITMAP_TEXT_STYLE_TYPES.forEach((bitmapTextStyleType) => {
        const { textStyle, chars } = ALL_BITMAP_TEXT_STYLE_PROPERTIES[bitmapTextStyleType];
        PIXI.BitmapFont.from(bitmapTextStyleType, textStyle, { chars, resolution: 2 });
    });
    console.log(`Bitmap Fonts created, took ${(performance.now() - startMs).toLocaleString()}ms`);
    bitmapFontsAreInitialized = true;
}
